<script>
  import {
    imgWrapper,
    title,
    paragraph,
    thankContainer,
  } from "./FormSubmitResponse.style";

  export let submitResponse = {
    success: true,
    title: "Berhasil",
    message:
      "Terimakasih telah mengisi data kamu, tim kami akan segera mengubungi kamu kembali",
  };
</script>

<div class={thankContainer} id="res-submit">
  <div class={imgWrapper}>
    {#if submitResponse.success}
      <img
        src="https://superyou.co.id/img/supertogether/checked.svg"
        alt="submit success" />
    {:else}
      <img
        src={`${process.env.APP_URL}/img/failed-icon.png`}
        alt="submit failed" />
    {/if}
  </div>
  <h2 class={title}>{submitResponse.title}</h2>
  <p class={paragraph}>{submitResponse.message}</p>
</div>
